import {mainQuery} from '@github-ui/react-core/future/main-query'

import {commitsAppBuilder} from '../config/app-builder'
import type {CommitsPayload} from '../types/commits-types'

export const commitsRefRoute = commitsAppBuilder.createQueryRouteConfig('commitsRefRoute', {
  path: '/:owner/:repo/commits/:ref',
  queries: [
    mainQuery<CommitsPayload>({
      queryDeps: ({pathname, searchParams}) => ({pathname, searchParams: searchParams.toString()}),
    }),
  ],
})
